/* eslint-disable no-param-reassign */
/* eslint-disable prefer-template */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/* eslint-enable no-unused-vars */

class MTableActions extends React.Component {
  renderButton(action, index) {
    if (typeof action === 'function') {
      action = action(this.props.data);
      if (!action) {
        return null;
      }
    }
    const actionIcon = action.toolbarIcon || action.icon;

    const { selectedRows } = this.props;

    const actionButton = (
      <Button
        key={action.icon + '' + index}
        disabled={
          action.disabled ||
          (!action.isFreeAction && selectedRows && selectedRows.length < 1)
        }
        className={classnames(action.toolbarClassName)}
        buttonStyle={action.buttonStyle}
        color={action.color}
        onClick={event => {
          if (action.onClick) {
            action.onClick(event, this.props.data);
            event.stopPropagation();
          }
        }}
        title={action.title}
        icon={<FontAwesomeIcon icon={actionIcon} />}
        iconAfter={action.iconAfter}
      >
        {action.title || action.tooltip}
      </Button>
    );
    return actionButton;
  }

  render() {
    if (this.props.actions) {
      return this.props.actions.map((action, index) =>
        this.renderButton(action, index)
      );
    }

    return null;
  }
}

MTableActions.defaultProps = {
  selectedRows: null,
  actions: [],
  data: {},
};

MTableActions.propTypes = {
  selectedRows: PropTypes.array,
  actions: PropTypes.array.isRequired,
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object),
  ]),
};

export default MTableActions;
/* eslint-enable prefer-template */
/* eslint-enable react/destructuring-assignment */
/* eslint-enable react/default-props-match-prop-types */
/* eslint-enable react/forbid-prop-types */
/* eslint-enable react/require-default-props */
/* eslint-enable no-param-reassign */
